const LOAD_DETAIL_CANDIDATE_REQUEST           = 'LOAD_DETAIL_CANDIDATE_REQUEST'
const LOAD_DETAIL_CANDIDATE_REQUEST_SUCCESS   = 'LOAD_DETAIL_CANDIDATE_REQUEST_SUCCESS'
const LOAD_DETAIL_CANDIDATE_REQUEST_FAILED    = 'LOAD_DETAIL_CANDIDATE_REQUEST_FAILED'
const UNMOUNT_DETAIL_CANDIDATE_REQUEST        = 'UNMOUNT_DETAIL_CANDIDATE_REQUEST'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const candidateRequestReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CANDIDATE_REQUEST_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CANDIDATE_REQUEST_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CANDIDATE_REQUEST:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default candidateRequestReducer;